import React, { useEffect, useState } from 'react';
import './index.scss';

import ListEditor from '../../ListEditor';

export default function Test({data, onUpdate, validator, ...rest}) {
    const [compData, setCompData] = useState({});
    validator.current = () => {
        var isValide;

        isValide = true; //is valide, save data
        isValide = false; //is not valide, do not save data and show default error message
        isValide = ""; //is not valide, do not save data and do not show error message
        isValide = "my error message"; //is not valide, do not save data and show custom error message
        isValide = false; //is not valide, do not save data and show default error message

        return isValide;
    };

    useEffect(() => {
        const defaultData = {val: ''};
        setCompData({
            ...defaultData,
            ...data
        });
    }, [data]);

    const updateCompData = (newData) => {
        setCompData(newData);
        onUpdate(newData);
    };

    const [list, setList] = useState([
        { id: 1, text: 'item1' },
        { id: 2, text: 'item2' },
        { id: 3, text: 'item3', disabled: true },
        { id: 4, text: 'item4' },
        { id: 5, text: 'item5', disabled: true },
        { id: 6, text: 'item6' },
        { id: 7, text: 'item7' },
        { id: 8, text: 'item8' }
    ]);

     return (
        <div>
            <ListEditor 
                isSortable={true} 
                canRemove={true} 
                canAdd={true}
                maxSize={10} 
                minSize={2} 
                emptyItem={ {text: 'new item' }}
                itemTitle={(data, settings) => {return `${settings.index} ${data.id} []`;}}
                itemContent={(data, settings) => {return <><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></>;}}
                title={(settings) => {return `[${settings.listLength}/${settings.maxSize}]`;}}
                list={list}
                onListUpdate={(newList) => {setList(newList)}}
                startElement={false}
            />
            <input value={compData.val} onChange={(e) => { updateCompData({...compData, val: e.target.value}); }}/>
        </div>
     );
};